import { useEffect, useState } from 'react';

import './GameResult.css';
import avaxlogo from '../../assets/avalanche-avax-logo.svg';

const payoutDefaultValue = [
    {
        "low":    [5.6, 2.1, 1.1, 1,   0.5, 1,   1.1, 2.1, 5.6],
        "medium": [13,  3,   1.3, 0.7, 0.4, 0.7, 1.3, 3,   13],
        "high":   [29,  4,   1.5, 0.3, 0.2, 0.3, 1.5, 4,   29],
    },
    {
        "low":    [5.6, 2, 1.6, 1,   0.7, 0.7, 1,   1.6, 2, 5.6],
        "medium": [18,  4, 1.7, 0.9, 0.5, 0.5, 0.9, 1.7, 4, 18],
        "high":   [43,  7, 2,   0.6, 0.2, 0.2, 0.6, 2,   7, 43],
    },
    {
        "low":    [8.9, 3,  1.4, 1.1, 1,   0.5, 1,   1.1, 1.4, 3,  8.9],
        "medium": [22,  5,  2,   1.4, 0.6, 0.4, 0.6, 1.4, 2,   5,  22],
        "high":   [76,  10, 3,   0.9, 0.3, 0.2, 0.3, 0.9, 3,   10, 76],
    },
    {
        "low":    [8.4, 3,  1.9, 1.3, 1,   0.7, 0.7, 1,   1.3, 1.9, 3,  8.4],
        "medium": [24,  6,  3,   1.8, 0.7, 0.5, 0.5, 0.7, 1.8, 3,   6,  24],
        "high":   [120, 14, 5.2, 1.4, 0.4, 0.2, 0.2, 0.4, 1.4, 5.2, 14, 120],
    },
    {
        "low":    [10,  3,  1.6, 1.4, 1.1, 1,   0.5, 1,   1.1, 1.4, 1.6, 3,  10],
        "medium": [33,  11, 4,   2,   1.1, 0.6, 0.3, 0.6, 1.1, 2,   4,   11, 33],
        "high":   [170, 24, 8.1, 2,   0.7, 0.2, 0.2, 0.2, 0.7, 2,   8.1, 24, 170],
    },
    {
        "low":    [8.1, 4,  3,  1.9, 1.2, 0.9, 0.7, 0.7, 0.9, 1.2, 1.9, 3,  4,  8.1],
        "medium": [43,  13, 6,  3,   1.3, 0.7, 0.4, 0.4, 0.7, 1.3, 3,   6,  13, 43],
        "high":   [260, 37, 11, 4,   1,   0.2, 0.2, 0.2, 0.2, 1,   4,   11, 37, 260],
    },
    {
        "low":    [7.1, 4,  1.9, 1.4, 1.3, 1.1, 1,   0.5, 1,   1.1, 1.3, 1.4, 1.9, 4,  7.1],
        "medium": [58,  15, 7,   4,   1.9, 1,   0.5, 0.2, 0.5, 1,   1.9, 4,   7,   15, 58],
        "high":   [420, 56, 18,  5,   1.9, 0.3, 0.2, 0.2, 0.2, 0.3, 1.9, 5,   18,  56, 420],
    },
    {
        "low":    [15,  8,  3,  2, 1.5, 1.1, 1,   0.7, 0.7, 1,   1.1, 1.5, 2, 3,  8,  15],
        "medium": [88,  18, 11, 5, 3,   1.3, 0.5, 0.3, 0.3, 0.5, 1.3, 3,   5, 11, 18, 88],
        "high":   [620, 83, 27, 8, 3,   0.5, 0.2, 0.2, 0.2, 0.2, 0.5, 3,   8, 27, 83, 620],
    },
    {
        "low":    [16,   9,   2,  1.4, 1.4, 1.2, 1.1, 1,   0.5, 1,   1.1, 1.2, 1.4, 1.4, 2,  9,   16],
        "medium": [110,  41,  10, 5,   3,   1.5, 1,   0.5, 0.3, 0.5, 1,   1.5, 3,   5,   10, 41,  110],
        "high":   [1000, 130, 26, 9,   4,   2,   0.2, 0.2, 0.2, 0.2, 0.2, 2,   4,   9,   26, 130, 1000],
    },
];

export default function GameResult({
    betAmount,
    ballsCount,
    rows,
    risk,
    show,
    handleClose,
    payoutMultiple,
}) {
    const showHideClassName = show ? "modal display-block" : "modal display-none";
    const [payoutSum, setPayoutSum] = useState();

    useEffect(() => {
        for (var i = 0, tmp = 0; i < payoutMultiple.length; i++) {
            tmp += payoutDefaultValue[rows - 8][risk][parseInt(payoutMultiple[i])];
        }
        setPayoutSum(tmp);
    }, [payoutMultiple, risk, rows]);

    return (
        <div className={showHideClassName}>
            <section className="modal-main">
                <section className='modal-header'>
                    <h1>Results</h1>
                </section>
                <section className='modal-content'>
                    <div className='bet-results'>
                        <div>
                            <span>Bet</span>
                            <span>
                                {Number(Number(betAmount * ballsCount).toFixed(2))}
                                <img src={avaxlogo} width={15} height={15} alt={'AvaxLogo'}></img>
                            </span>
                        </div>
                        <div>
                            <span>Multipliers</span>
                            <span>{Number(Number(Number(payoutSum).toFixed(1) / ballsCount).toFixed(2))}×</span>
                        </div>
                        <div>
                            <span>Payout</span>
                            <span>
                                {Number(Number(betAmount * payoutSum).toFixed(3))}
                                <img src={avaxlogo} width={15} height={15} alt='AvaxLogo'></img>
                            </span>
                        </div>
                    </div>
                    <div className='multiplier-details'>
                    </div>
                </section>
                <section className='modal-footer'>
                    <button type="button" onClick={handleClose} className="game-close-btn">Close</button>
                </section>    
            </section>
        </div>
    );
};